import Balance from "@mui/icons-material/Balance";
import CompareArrows from "@mui/icons-material/CompareArrows";
import { StatusChip } from "components/StatusChip";
import { ReconciliationState } from "generated-graphql/graphql";

import { RECONCILIATION_CHIP_COLORS, RECONCILIATION_LABELS } from "./reconciliationDisplay";

/**
 * A glyph for the two verdicts that ARE a comparison: scales for agreement,
 * opposed arrows for a difference.
 *
 * `NONE` and `NOT_REVIEWED` deliberately have none. Both mean the comparison did
 * not happen, and an icon would give them the same visual footing as a verdict
 * that was actually reached.
 */
const RECONCILIATION_ICONS: Partial<Record<ReconciliationState, React.ReactElement>> = {
  [ReconciliationState.InSync]: <Balance />,
  [ReconciliationState.Discrepant]: <CompareArrows />,
};

/**
 * The reconciliation state as a chip, following `WasteShipmentStatusChip`:
 * semantic color, small, outlined.
 *
 * `NONE` renders nothing by default. Most surfaces show this chip in a grid or
 * beside a row, where a chip on every unlinked shipment would be noise — the
 * absence of a manifest is already visible from the shipment's own state. Pass
 * `showNone` where the blank would instead read as missing data.
 */
export function ShipmentReconciliationChip({
  status,
  showNone = false,
}: {
  status: ReconciliationState;
  showNone?: boolean;
}) {
  if (status === ReconciliationState.None && !showNone) {
    return null;
  }
  return (
    <StatusChip
      label={RECONCILIATION_LABELS[status]}
      color={RECONCILIATION_CHIP_COLORS[status]}
      icon={RECONCILIATION_ICONS[status]}
      variant="outlined"
    />
  );
}
